import {Component, OnInit, OnDestroy} from '@angular/core';
import {UsersService, StorageService, CurrencyService} from '../../services';


@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    providers: [CurrencyService],
})
export class UserProfileComponent implements OnInit {
    travels: any;
    activeTab: number;
    user: any;
    exchangeRate: any;
    isLoaded: boolean;


    constructor(
        private usersService: UsersService,
        private currencyService: CurrencyService,
        private storage: StorageService
    ) {
    }

    ngOnInit() {
        this.activeTab = 1;
        // this.user = this.storage.user;
        // console.log('!!!!!!this.user ', this.user );
        this.getProfile();
        this.getProfileTravels();
    }

    changeTab(index: number, isDisabled?: boolean) {
        if (!isDisabled) {
            this.activeTab = index;
        }
        if (this.activeTab === 1) {
            this.getProfileTravels();
            this.getProfile();
        }
    }

    private getProfile() {
        this.isLoaded = false;
        this.usersService.getProfile().subscribe((res) => {
            if (res) {
                this.isLoaded = true;
                this.user = res;
                // if (!this.pageUserName) {
                //   this.routingService.pageTitle(this.pageTitle, this.user.name);
                // }
            }
        }, (err) => {
            // this.toast.showToastFromError(err);
            console.log('error: ', err)
        });
    }

    private getProfileTravels() {

        this.usersService.getProfileTravels().subscribe((result) => {
            if (result) {
                // this.isLoaded = true;
                this.travels = result;
                const param = {paging: {offset: 0, limit: 1}, sorting: {propertyName: 'created_at', sortingType: 1}};
                this.currencyService.getCurrency(param).subscribe(data => {
                    if (data) {
                        this.exchangeRate = data.items[0];
                        this.travels.map((travel) => {
                            travel.locations.forEach(item => {
                                item.services.filter(res => {
                                        if (res.cost && res.cost.value && res.cost.currency) {
                                            switch (res.cost.currency.name) {
                                                case 'UAH':
                                                    travel.totalCost.uah += res.cost.value;
                                                    break;
                                                case 'USD':
                                                    travel.totalCost.usd += res.cost.value;
                                                    break;
                                                case 'EUR':
                                                    travel.totalCost.eur += res.cost.value;
                                                    break;
                                            }
                                        }
                                    }
                                );
                            });

                            travel.cost = 0;
                            if (!travel.currency) {
                                travel.currency = 'USD';
                            }
                            travel.exchangeRate.usd = travel.exchangeRate.usd || this.getLowerRate(+this.exchangeRate.usdAsk, +this.exchangeRate.usdBid);
                            travel.exchangeRate.eur = travel.exchangeRate.eur || this.getLowerRate(+this.exchangeRate.eurAsk, +this.exchangeRate.eurBid);
                            travel.exchangeRate.eurUSD = this.getLowerRate(+this.exchangeRate.eurUSDask, +this.exchangeRate.eurUSDbid);
                            travel.exchangeRate.usdEur = this.getLowerRate(+this.exchangeRate.usdEURask, +this.exchangeRate.usdEURbid);
                            travel.exchangeRate.isUsdRateUsed = travel.totalCost.usd > 0 || travel.currency === 'USD';
                            travel.exchangeRate.isEurRateUsed = travel.totalCost.eur > 0 || travel.currency === 'EUR';
                            travel.exchangeRate.isCrossRateEURUSD = travel.totalCost.eur > 0 || travel.currency === 'USD';
                            travel.exchangeRate.isCrossRateUSDEUR = travel.totalCost.usd > 0 || travel.currency === 'EUR';


                            const totalCost = {
                                uah: travel.totalCost.uah,
                                eur: travel.totalCost.eur,
                                usd: travel.totalCost.usd
                            };
                            switch (travel.bankExpensesCurrency) {
                                case 1:
                                    travel.totalCost.uah += travel.bankExpenses;
                                    break;
                                case 2:
                                    travel.totalCost.eur += travel.bankExpenses;
                                    break;
                                case 3:
                                    travel.totalCost.usd += travel.bankExpenses;
                                    break;
                                case 5:
                                    travel.totalCost.uah += totalCost.uah * travel.bankExpenses / 100;
                                    travel.totalCost.eur += totalCost.eur * travel.bankExpenses / 100;
                                    travel.totalCost.usd += totalCost.usd * travel.bankExpenses / 100;
                                    break;
                            }

                            switch (travel.serviceFeeCurrency) {
                                case 1:
                                    travel.totalCost.uah += travel.serviceFee;
                                    break;
                                case 2:
                                    travel.totalCost.eur += travel.serviceFee;
                                    break;
                                case 3:
                                    travel.totalCost.usd += travel.serviceFee;
                                    break;
                                case 5:
                                    travel.totalCost.uah += totalCost.uah * travel.serviceFee / 100;
                                    travel.totalCost.eur += totalCost.eur * travel.serviceFee / 100;
                                    travel.totalCost.usd += totalCost.usd * travel.serviceFee / 100;
                                    break;
                            }


                            const currT = travel.invoices[travel.invoices.length - 1]?.type;
                            switch (currT) {
                                case 1:
                                    travel.cost += travel.totalCost.uah;
                                    travel.cost += travel.totalCost.usd * travel.exchangeRate.usd;
                                    travel.cost += travel.totalCost.eur * travel.exchangeRate.eur;
                                    break;
                                case 2:
                                    travel.cost += travel.totalCost.eur;
                                    travel.cost += travel.totalCost.uah / travel.exchangeRate.eur;
                                    travel.cost += travel.totalCost.usd * travel.exchangeRate.usdEur;
                                    break;
                                case 3:
                                    travel.cost += travel.totalCost.usd;
                                    travel.cost += travel.totalCost.uah / travel.exchangeRate.usd;
                                    travel.cost += travel.totalCost.eur * travel.exchangeRate.eurUSD;
                                    break;
                                case 4:
                                    travel.cost += travel.totalCost.usd;
                                    travel.cost += travel.totalCost.uah / travel.exchangeRate.usd;
                                    travel.cost += travel.totalCost.eur * travel.exchangeRate.eurUSD;
                                    break;
                            }

                            const partlyInvoice = travel.invoices.filter(invoice => invoice.is_partial);

                            if (partlyInvoice) {
                                partlyInvoice.cost = {
                                    uah: 0,
                                    usd: 0,
                                    eur: 0,
                                };
                                partlyInvoice.forEach((item) => {
                                    if (item.status.id === 2) {
                                        switch (item.type) {
                                            case 1:
                                                partlyInvoice.cost.uah += item.amount;
                                                partlyInvoice.cost.usd += item.amount / travel.exchangeRate.usd;
                                                partlyInvoice.cost.eur += item.amount / travel.exchangeRate.eur;
                                                break;
                                            case 3:
                                                partlyInvoice.cost.usd += item.amount;
                                                partlyInvoice.cost.uah += item.amount * travel.exchangeRate.usd;
                                                partlyInvoice.cost.eur += item.amount * travel.exchangeRate.usdEur;
                                                break;
                                            case 2:
                                                partlyInvoice.cost.eur += item.amount;
                                                partlyInvoice.cost.uah += item.amount * travel.exchangeRate.eur;
                                                partlyInvoice.cost.usd += item.amount * travel.exchangeRate.eurUSD;
                                                break;
                                            case 4:
                                                partlyInvoice.cost.usd += item.amount;
                                                partlyInvoice.cost.uah += item.amount * travel.exchangeRate.usd;
                                                partlyInvoice.cost.eur += item.amount * travel.exchangeRate.usdEur;
                                                break;
                                        }
                                    }
                                });
                                travel.partlyInvoice = partlyInvoice;
                            }
                        });
                    }
                }, (err) => {
                    // this.toast.showToastFromError(err);
                });
                this.travels = this.usersService.sortElement(this.travels, 'dateFrom', 'desc');
                // if (!this.pageUserName) {
                //   this.routingService.pageTitle(this.pageTitle, this.user.name);
                // }
            }
        }, (err) => {
            // this.toast.showToastFromError(err);
            console.log('error: ', err)
        });
    }

    private getLowerRate(ask: number, bid: number) {
        return ask < bid ? ask : bid;
    }
}
